import { toFloat } from '../helpers/math_helper';

const datas = {};

datas.simulation_period        = parseInt(document.getElementById('sim-period').value);
datas.prices_variations_period = parseInt(document.getElementById('energies-price-variations-period').value);
datas.crysis_energy_ratio      = 1.3;

/*
 * identifier           [string]  : identifier for translation
 * price                [float]   : current price of the energy in euro cents by kWh
 * price_variation      [float]   : current price variation (will be calculated and filled later)
 * primary_energy_ratio [float]   : primary energy ratio in kWhep by kWhef
 * ghg_ratio            [float]   : greenhouse gas ratio
 * volume_ratio         [float]   : volume needed to store the wood
 * pci_ratio            [float]   : "Pouvoir Calorifique Inférieur" ratio
 */
datas.energy_types = [
  { id: 1,  identifier: 'oil',           primary_energy_ratio: 1.00, ghg_ratio: 0.265 },
  { id: 2,  identifier: 'gaz_b1',        primary_energy_ratio: 1.00, ghg_ratio: 0.202 },
  { id: 3,  identifier: 'propane',       primary_energy_ratio: 1.00, ghg_ratio: 0.28  },
  { id: 4,  identifier: 'electricity',   primary_energy_ratio: 2.58, ghg_ratio: 0.18  },
  { id: 5,  identifier: 'bulk_granules', primary_energy_ratio: 0.60, ghg_ratio: 0.04, pci_ratio: 4700, density_ratio: 0.65 },
  { id: 6,  identifier: 'bag_granules',  primary_energy_ratio: 0.60, ghg_ratio: 0.04, pci_ratio: 4700, density_ratio: 0.65 },
  { id: 7,  identifier: 'wood',          primary_energy_ratio: 0.60, ghg_ratio: 0.02, pci_ratio: 3000, density_ratio: 0.27 },
  { id: 8,  identifier: 'shredded_wood', primary_energy_ratio: 0.60, ghg_ratio: 0.02, pci_ratio: 3500, density_ratio: 0.25 },
];

datas.green_electricity_ghg_ratio = 0.007; // http://www.enercoop.fr/content/calcul-des-emissions-de-co2-des-fournisseurs-delectricite-quelle-methode-utiliser

/*
 * oil           : - (c€/kWhPCI)
 * gaz_b1        : prix complet abo B1 + conso (c€/kWh PCI)
 * propane       : - (c€/kWhPCI)
 * electricity   : prix complet abo 12 kVA option HC (c€/kWh)
 * wood          : - (c€/kWhPCI)
 * shredded_wood : - (c€/kWhPCI)
 * bulk_granules : - (c€/kWhPCI)
 * bag_granules  : - (c€/kWhPCI)
 */
datas.energies_yearly_price_variations = [
  { year: 1996, oil: 3.35, gaz_b1: 4.03, propane: 5.99,  electricity: 11.91, wood: null, shredded_wood: null, bulk_granules: null, bag_granules: null },
  { year: 1997, oil: 3.52, gaz_b1: 4.19, propane: 6.81,  electricity: 11.68, wood: 2.55, shredded_wood: 2.04, bulk_granules: 3.28, bag_granules: 5.76 },
  { year: 1998, oil: 3.02, gaz_b1: 4.24, propane: 6.8,   electricity: 11.42, wood: 2.6,  shredded_wood: 2.08, bulk_granules: 3.34, bag_granules: 5.88 },
  { year: 1999, oil: 3.29, gaz_b1: 3.92, propane: 6.44,  electricity: 10.87, wood: 2.66, shredded_wood: 2.12, bulk_granules: 3.41, bag_granules: 6.0 },
  { year: 2000, oil: 4.64, gaz_b1: 4.09, propane: 7.33,  electricity: 10.63, wood: 2.71, shredded_wood: 2.16, bulk_granules: 3.48, bag_granules: 6.12 },
  { year: 2001, oil: 3.95, gaz_b1: 4.88, propane: 7.5,   electricity: 10.58, wood: 2.77, shredded_wood: 2.21, bulk_granules: 3.55, bag_granules: 6.24 },
  { year: 2002, oil: 3.67, gaz_b1: 4.9,  propane: 7.44,  electricity: 10.69, wood: 2.82, shredded_wood: 2.25, bulk_granules: 3.63, bag_granules: 6.37 },
  { year: 2003, oil: 3.91, gaz_b1: 5.02, propane: 8.21,  electricity: 10.81, wood: 2.88, shredded_wood: 2.3,  bulk_granules: 3.7,  bag_granules: 6.5 },
  { year: 2004, oil: 4.51, gaz_b1: 4.77, propane: 8.44,  electricity: 10.95, wood: 2.97, shredded_wood: 2.3,  bulk_granules: 3.8,  bag_granules: 6.27 },
  { year: 2005, oil: 5.89, gaz_b1: 5.17, propane: 9.64,  electricity: 10.95, wood: 3.24, shredded_wood: 2.4,  bulk_granules: 4.04, bag_granules: 6.27 },
  { year: 2006, oil: 6.51, gaz_b1: 6.11, propane: 10.7,  electricity: 11.01, wood: 3.24, shredded_wood: 2.5,  bulk_granules: 4.47, bag_granules: 6.27 },
  { year: 2007, oil: 6.53, gaz_b1: 5.14, propane: 10.87, electricity: 10.68, wood: 3.59, shredded_wood: 2.6,  bulk_granules: 4.66, bag_granules: 5.66 },
  { year: 2008, oil: 8.36, gaz_b1: 5.45, propane: 12.27, electricity: 10.56, wood: 3.6,  shredded_wood: 2.6,  bulk_granules: 4.66, bag_granules: 5.5 },
  { year: 2009, oil: 5.77, gaz_b1: 5.64, propane: 10.68, electricity: 10.93, wood: 3.5,  shredded_wood: 2.6,  bulk_granules: 4.71, bag_granules: 5.54 },
  { year: 2010, oil: 7.18, gaz_b1: 5.44, propane: 11.39, electricity: 11.83, wood: 3.7,  shredded_wood: 2.7,  bulk_granules: 4.82, bag_granules: 5.51 },
  { year: 2011, oil: 8.9,  gaz_b1: 6.05, propane: 13.07, electricity: 12.84, wood: 3.7,  shredded_wood: 2.9,  bulk_granules: 5.19, bag_granules: 5.79 },
  { year: 2012, oil: 9.72, gaz_b1: 6.55, propane: 14.01, electricity: 13.21, wood: 3.9,  shredded_wood: 2.9,  bulk_granules: 5.27, bag_granules: 5.83 },
  { year: 2013, oil: 9.3,  gaz_b1: 6.99, propane: 13.27, electricity: 14.31, wood: 4.3,  shredded_wood: 3.1,  bulk_granules: 5.68, bag_granules: 6.2 },
  { year: 2014, oil: 8.62, gaz_b1: 7.26, propane: 13.38, electricity: 15.15, wood: 4.4,  shredded_wood: 3.4,  bulk_granules: 6.13, bag_granules: 6.57 },
  { year: 2015, oil: 7.08, gaz_b1: 7.14, propane: 12.56, electricity: 15.56, wood: 4.0,  shredded_wood: 3.14, bulk_granules: 5.83, bag_granules: 6.09 },
  { year: 2016, oil: 6.39, gaz_b1: 6.61, propane: 11.93, electricity: 15.81, wood: 3.9,  shredded_wood: 3.03, bulk_granules: 5.67, bag_granules: 5.99 },
  { year: 2017, oil: 7.43, gaz_b1: 6.62, propane: 13.16, electricity: 15.77, wood: 4.2,  shredded_wood: 3.06, bulk_granules: 5.69, bag_granules: 5.97 },
  { year: 2018, oil: 9.14, gaz_b1: 7.13, propane: 14.3,  electricity: 16.17, wood: 4.5,  shredded_wood: 3.09, bulk_granules: 5.87, bag_granules: 6.05 },
  { year: 2019, oil: 9.36, gaz_b1: 7.36, propane: 15.0,  electricity: 16.01, wood: 4.62,  shredded_wood: 3.16, bulk_granules: 6.09, bag_granules: 6.26 },
];

datas.energies_for_price_variations_chart = ['oil', 'gaz_b1', 'propane', 'electricity', 'wood', 'shredded_wood', 'bulk_granules'];
datas.energies_price_ref_year = 1999;

/*
 * identifier     [string]  : identifier for translation
 * energy_type_id [integer] : foreign key with energy_types table
 * efficiency     [float]   : system efficiency
 * investment     [float]   : initial investment cost minus french state aids
 * maintenance    [float]   : yearly cost of system maintenance
 * hydro          [boolean] : centralised hydraulic system
 * enr_ratio      [float]   : renewable energy ratio
 */
datas.heating_systems = [
  { id: 1,  identifier: 'standard_oil',          energy_type_id: 1, efficiency: 0.82, secondary_efficiency: 0.85, investment: 5000,  maintenance: 150, hydro: true,  enr_ratio: 0 },
  { id: 2,  identifier: 'condensation_oil',      energy_type_id: 1, efficiency: 0.93, secondary_efficiency: 0.85, investment: 6000,  maintenance: 150, hydro: true,  enr_ratio: 0 },
  { id: 3,  identifier: 'standard_gaz',          energy_type_id: 2, efficiency: 0.82, secondary_efficiency: 0.85, investment: 4000,  maintenance: 150, hydro: true,  enr_ratio: 0 },
  { id: 4,  identifier: 'condensation_gaz',      energy_type_id: 2, efficiency: 0.95, secondary_efficiency: 0.85, investment: 5000,  maintenance: 150, hydro: true,  enr_ratio: 0 },
  { id: 5,  identifier: 'standard_propane',      energy_type_id: 3, efficiency: 0.82, secondary_efficiency: 0.85, investment: 5000,  maintenance: 150, hydro: true,  enr_ratio: 0 },
  { id: 6,  identifier: 'condensation_propane',  energy_type_id: 3, efficiency: 0.95, secondary_efficiency: 0.85, investment: 6000,  maintenance: 150, hydro: true,  enr_ratio: 0 },
  { id: 7,  identifier: 'electric',              energy_type_id: 4, efficiency: 1.0,  secondary_efficiency: 0.95, investment: 3000,  maintenance: 0,   hydro: false, enr_ratio: 0 },
  { id: 8,  identifier: 'pac_air_air',           energy_type_id: 4, efficiency: 1.87, secondary_efficiency: 0.85, investment: 6000,  maintenance: 200, hydro: false, enr_ratio: 0 },
  { id: 9,  identifier: 'pac_air_water',         energy_type_id: 4, efficiency: 2.2,  secondary_efficiency: 0.85, investment: 12000, maintenance: 200, hydro: true,  enr_ratio: 0 },
  { id: 10, identifier: 'pac_geothermal_bt',     energy_type_id: 4, efficiency: 3.4,  secondary_efficiency: 0.85, investment: 20000, maintenance: 200, hydro: true,  enr_ratio: 0.241 },
  { id: 11, identifier: 'pac_geothermal_tbt',    energy_type_id: 4, efficiency: 3.8,  secondary_efficiency: 0.85, investment: 20000, maintenance: 200, hydro: true,  enr_ratio: 0.321 },
  { id: 12, identifier: 'pac_heat_recup',        energy_type_id: 4, efficiency: 5.2,  secondary_efficiency: 0.85, investment: 15000, maintenance: 200, hydro: true,  enr_ratio: 0.504 },
  { id: 13, identifier: 'recent_wooden_stove',   energy_type_id: 7, efficiency: 0.7,  secondary_efficiency: 1.0,  investment: 3000,  maintenance: 80,  hydro: false, enr_ratio: 1 },
  { id: 14, identifier: 'granules_stove',        energy_type_id: 6, efficiency: 0.8,  secondary_efficiency: 1.0,  investment: 5000,  maintenance: 100, hydro: false, enr_ratio: 1 },
  { id: 15, identifier: 'granules_furnace',      energy_type_id: 5, efficiency: 0.85, secondary_efficiency: 0.85, investment: 16000, maintenance: 250, hydro: true,  enr_ratio: 1 },
  { id: 16, identifier: 'wood_furnace',          energy_type_id: 7, efficiency: 0.72, secondary_efficiency: 0.85, investment: 12000, maintenance: 200, hydro: true,  enr_ratio: 1 },
  { id: 17, identifier: 'shredded_wood_furnace', energy_type_id: 8, efficiency: 0.8,  secondary_efficiency: 0.85, investment: 25000, maintenance: 400, hydro: true,  enr_ratio: 1 },
];

/*
 * identifier     [string]  : identifier for translation
 * energy_type_id [integer] : foreign key with energy_types table
 * efficiency     [float]   : system efficiency
 * investment     [float]   : initial investment cost minus french state aids
 * maintenance    [float]   : yearly cost of system maintenance
 * hydro          [boolean] : centralised hydraulic system
 * enr_ratio      [float]   : renewable energy ratio
 */
datas.hot_water_systems = [
  { id: -1, identifier: 'none' },
  { id: 0,  identifier: 'same', investment: 750},
  // Shared hot water systems with heating systems
  { id: 1,  identifier: 'standard_oil',          efficiency: 0.6 },
  { id: 2,  identifier: 'condensation_oil',      efficiency: 0.6 },
  { id: 3,  identifier: 'standard_gaz',          efficiency: 0.62 },
  { id: 4,  identifier: 'condensation_gaz',      efficiency: 0.72 },
  { id: 5,  identifier: 'standard_propane',      efficiency: 0.62 },
  { id: 6,  identifier: 'condensation_propane',  efficiency: 0.72 },
  { id: 7,  identifier: 'electric',              efficiency: 0.75 },
  { id: 8,  identifier: 'pac_air_air',           efficiency: 1.36 },
  { id: 9,  identifier: 'pac_air_water',         efficiency: 1.36 },
  { id: 10, identifier: 'pac_geothermal_bt',     efficiency: 1.36 },
  { id: 11, identifier: 'pac_geothermal_tbt',    efficiency: 1.36 },
  { id: 12, identifier: 'pac_heat_recup',        efficiency: 1.36 },
  { id: 13, identifier: 'recent_wooden_stove',   efficiency: 0.58 },
  { id: 14, identifier: 'granules_stove',        efficiency: 0.68 },
  { id: 15, identifier: 'granules_furnace',      efficiency: 0.72 },
  { id: 16, identifier: 'wood_furnace',          efficiency: 0.65 },
  { id: 17, identifier: 'shredded_wood_furnace', efficiency: 0.68 },
  // Specific hot water systems
  { id: 18, identifier: 'hot_water_tank',        efficiency: 0.75, energy_type_id: 4, investment: 500,  maintenance: 0,   hydro: false, enr_ratio: 0 },
  { id: 19, identifier: 'thermo',                efficiency: 1.36, energy_type_id: 4, investment: 3000, maintenance: 100, hydro: false, enr_ratio: 0 },
];

// Average hot water consumption for one person
datas.hot_water_conso_per_person = 680;

/*
 * identifier       [string]  : identifier for translation
 * heating_ratio    [integer] : heating ratio
 * hot_water_ratio  [float]   : hot water ratio
 * investment_by_m2 [float]   : initial investment cost by m2 minus french state aids
 */
datas.solar_systems = [
  { id: 1, identifier: 'cesi', heating_ratio: 0,   hot_water_ratio: 400, investment_by_m2: 1000 },
  { id: 2, identifier: 'ssc',  heating_ratio: 400, hot_water_ratio: 400, investment_by_m2: 1000 },
];

datas.solar_max_prod_covering = {
  heating   : 0.6,
  hot_water : 0.6,
};

datas.solar_maintenance = {
  with_hydro    : 80,  // cost when considered installation already have a hydro maintenance cost (gaz, oil, etc.)
  without_hydro : 150, // cost when considered installation doesn't have a hydro maintenance cost (electricty, pac)
};

// Source : Dialogie (base : maison ind. de 100m² à Lyon / 4 occupants) et Hespul "Intégrer l’énergie dans les projets d’aménagement, 2015"
datas.building_years = [
  { id: 1,  identifier: 'before_1948',         heating_ratio: 220 },
  { id: 2,  identifier: 'before_1975',         heating_ratio: 300 },
  { id: 3,  identifier: 'between_1975_1982',   heating_ratio: 220 }, // RT 74
  { id: 4,  identifier: 'between_1983_1988',   heating_ratio: 160 }, // RT 82
  { id: 5,  identifier: 'between_1989_2000',   heating_ratio: 120 }, // RT 88
  { id: 6,  identifier: 'between_2001_2005',   heating_ratio: 100 }, // RT 2000
  { id: 7,  identifier: 'between_2006_2012',   heating_ratio: 85 },  // RT 2005
  { id: 8,  identifier: 'after',               heating_ratio: 32 },  // RT 2012
  { id: 9,  identifier: 'bbc',                 heating_ratio: 60 },  // Label BBC
  { id: 10, identifier: 'passive',             heating_ratio: 15 },  // Label Passiv Haus
];

datas.current_heating_efficiency = 0.85;

datas.energy_vectors = [
  { id: 1,  identifier: 'oil_kg',            pci: 11.8 },
  { id: 2,  identifier: 'oil_l',             pci: 10.384 },
  { id: 3,  identifier: 'propane_kg',        pci: 12.88 },
  { id: 4,  identifier: 'propane_m3',        pci: 7728 },
  { id: 5,  identifier: 'propane_bottles',   pci: 167 },
  { id: 6,  identifier: 'natural_gaz_kwh',   pci: 1 },
  { id: 7,  identifier: 'electricity_kwh',   pci: 1 },
  { id: 8,  identifier: 'wooden_stones',     pci: 1700 },
  { id: 9,  identifier: 'granules_t',        pci: 4700 },
  { id: 10, identifier: 'shredded_wood_t',   pci: 3500 },
  { id: 11, identifier: 'shredded_wood_map', pci: 875 },
  { id: 12, identifier: 'shredded_wood_kwh', pci: 1 },
];

// Car greenhouse gaz production ratio
datas.ghg_by_car_ratio = 0.217;

//------------------------------------------------------------------------------
//  REQUESTS
//------------------------------------------------------------------------------

datas.requests = {
  get_heating_system: heatingSystemId => {
    return datas.heating_systems.find( heating_system => heating_system.id == heatingSystemId);
  },
  get_hot_water_system: hotWaterSystemId => {
    const heatingEquivalent = datas.heating_systems.find( heating_system => heating_system.hot_water_id == hotWaterSystemId);
    const hotWaterSystem = datas.hot_water_systems.find( hot_water_system => hot_water_system.id == hotWaterSystemId);

    return Object.assign({}, heatingEquivalent, hotWaterSystem);
  },
  get_energy_type_by_id: energyTypeId => {
    return datas.energy_types.find( energy_type => energy_type.id == energyTypeId);
  },
  get_energy_type: energyType => {
    return datas.energy_types.find( energy_type => energy_type.identifier == energyType);
  },
  get_building_year: buildingYearId => {
    return datas.building_years.find( building_year => building_year.id == buildingYearId);
  },
  get_energy_vector: energyVectorId => {
    return datas.energy_vectors.find( energy_vector => energy_vector.id == energyVectorId);
  },
  get_solar_system: solarSystemId => {
    return datas.solar_systems.find( solar_system => solar_system.id == solarSystemId);
  },
  get_ref_year_index: () => {
    let refYearIndex = null;
    datas.energies_yearly_price_variations.forEach( (data, index) => {
      if (data.year == datas.energies_price_ref_year) refYearIndex = index;
    });
    return refYearIndex;
  },
}


//------------------------------------------------------------------------------
//  FUCNTIONS
//------------------------------------------------------------------------------

const compute = {
  yearly_price_variations: energyType => {
    return datas.energies_yearly_price_variations.map( price => {
      return price[energyType];
    });
  },
  price_avg_from_three_last_years: priceVariations => {
    return priceVariations.slice(-3).reduce( (sum, price) => { return sum + price }) / 3;
  },
  price_avg_from_ref_year: priceVariations => {
    const refYearIndex = datas.requests.get_ref_year_index() ;
    return priceVariations.slice(refYearIndex-2, refYearIndex+1).reduce( (sum, price) => { return sum + price } ) / 3;
  },
  mean_yearly_price_variation: priceVariations => {
    const lastYear               = datas.energies_yearly_price_variations.slice(-1)[0].year;
    const refYear                = datas.energies_price_ref_year;
    const avgPriceThreeLastYears = compute.price_avg_from_three_last_years(priceVariations);
    const avgPriceFromRefYear    = compute.price_avg_from_ref_year(priceVariations);

    return (Math.pow( (avgPriceThreeLastYears / avgPriceFromRefYear), (1 / (lastYear - refYear))) - 1);
  },
};


//------------------------------------------------------------------------------
//  GENERATED DATAS
//------------------------------------------------------------------------------

// Concat parameters of heating systems equivalents to hot water systems
datas.hot_water_systems = datas.hot_water_systems.map( (hot_water_system, i) => {
  return Object.assign({}, datas.requests.get_heating_system(hot_water_system.id), hot_water_system);
});

// Update energy_types datum to fill in the price and price_variation from energies_yearly_price_variations
datas.energy_types.map( energy => {
  const energyType                   = energy.identifier;
  let priceVariations              = compute.yearly_price_variations(energyType);
  const avgPriceThreeLastYears       = compute.price_avg_from_three_last_years(priceVariations);

  if (energyType === 'bag_granules') {
    priceVariations = compute.yearly_price_variations('bulk_granules');
  }
  const meanYearlyPriceVariation = compute.mean_yearly_price_variation(priceVariations);

  energy['price'] = toFloat(avgPriceThreeLastYears);
  energy['price_variation'] = meanYearlyPriceVariation;

  return energy
});


//------------------------------------------------------------------------------

export default datas;



// WEBPACK FOOTER //
// ./assets/javascripts/datas/_datas.js